export default function offerNameOptionsResolver({ offer, itemSettings }) {
    return {
        bind: {
            name: offer.name,
            settings: itemSettings,
        },
    };
}
